import { Modules } from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled';
import smoothscroll from 'smoothscroll-polyfill';
import { getElementOffset } from 'utils';

class HeroSection extends PureComponent {
    constructor() {
        super();
        this.state = {};
        this.renderWrapper = this.renderWrapper.bind(this);
        this.scrollToContents = this.scrollToContents.bind(this);
    }

    scrollToContents() {
        window.scrollTo({
            top: getElementOffset(this.hero).bottom + 1,
            left: 0,
            behavior: 'smooth',
        });
    }

    componentDidMount() {
        this.heroOnLoad = () => {
            if (document.getElementById('CloneWrapper')) {
                document
                    .getElementById('CloneWrapper')
                    .classList.add('fadeout');
            }
        };
    }
    heroOnLoad() {}

    componentDidMount() {
        smoothscroll.polyfill();
        this.setState({ boundary: window.innerHeight });
    }
    renderModules() {
        const { caseSections } = this.props;
        const modules = _get(this.props, 'modules', []);
        return modules.map((module, i) => (
            <Modules
                heroOnLoad={this.heroOnLoad}
                key={`${module.id}_${i}`}
                {...{
                    ...this.props,
                    content: {
                        ...module,
                        teaserImageWide: this.props.data.teaserImageWide,
                        caseSections: caseSections,
                    },
                }}
            />
        ));
    }

    renderWrapper() {
        const { showArrowCursor, textColor } = this.props;

        return (
            <HeroSectionWrapper
                ref={el => (this.hero = el)}
                onClick={showArrowCursor ? this.scrollToContents : null}
                data-cursor="hero"
                data-cursor-persistance="500"
                data-cursor-click-persistance="150"
                textColor={textColor}>
                <HeroWrapper>{this.renderModules()}</HeroWrapper>
            </HeroSectionWrapper>
        );
    }

    render() {
        return this.renderWrapper();
    }
}

export const HeroSectionWrapper = styled.div`
    color: ${props => props.textColor};
    position: relative;
    /* height: 100vh; */
    width: 100vw;
    // overflow: hidden;

`;

const HeroWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    background-color: ${props => props.backgroundColor};
`;

export default HeroSection;
